import Axios from 'axios';

const internals = {
    // expected that REACT_APP_API_HOST and REACT_APP_CONTENT_DIR have trailing slashes
    host: `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_CONTENT_DIR}${process.env.REACT_APP_API_PREFIX}`,
    getApiBase: () => {
        const { host } = internals;

        return `${host}`;
    },
};

const client = Axios.create({
    baseURL: internals.getApiBase(),
    responseType: 'json',
    headers: {
        common: {},
    },
});
export default client;

client.batch = (reqs) => {
    const requests = reqs.map((request) => ({
        ...request,
        path: request.path,
    }));

    return client.post(internals.getApiBase(), { requests });
};

client.updateAuth = (newToken) => {
    const headers = client.defaults.headers.common;

    if (!newToken) {
        return delete headers.authorization;
    }

    headers.authorization = `Bearer ${newToken}`;

    return true;
};
